import React from 'react'
import './App.css';
import Login from './pages/auth/Login';
import Dashboard from './pages/Dashboard';
import Customer from './pages/Customer';
import CustomerDetail from './pages/CustomerDetail';
import PriceChannel from './pages/PriceChannel';

import Price from './pages/Price';
import PriceOtherChannel from './pages/PriceOtherChannel';


import Message from './pages/Message';
import GetStarted from './pages/GetStarted';
import Contact from './pages/Contact';
import WebHook from './pages/WebHook';
import SendMessage from './pages/SendMessage';
import { PrivateRoute } from './components';


import Setting from './pages/Setting';
import Country from './pages/setting/Country';
import Operator from './pages/setting/Operator';
import User from './pages/setting/User';
import Status from './pages/setting/Status';
//import Sender from './pages/setting/Sender';
import SdkUrl from './pages/setting/SdkUrl';

import Channel from './pages/setting/Channel';
import RoutingMethod from './pages/setting/RoutingMethod';

import ChannelApiConfig from './pages/setting/ChannelApiConfig';


import MessageType from './pages/setting/MessageType';
import MessageTemplateType from './pages/setting/MessageTemplateType';
import TemplateMessage from './pages/setting/TemplateMessage';
import Variables from './pages/setting/Variables';

import Sms from './pages/setting/Sms';
import Whatsapp from './pages/setting/Whatsapp';

import { Routes, Route } from "react-router-dom";
import { ChakraProvider } from '@chakra-ui/react';
import theme from './theme';
import ChannelList from './pages/Salescontract/SaleList';
import SaleList from './pages/Salescontract';
import Categories from './pages/setting/Categories';
import MessageLogReport from './pages/message/Report';
import MessageParser from './pages/MessageParser/MessageParser';
import CurrencyList from './pages/setting/Currency';
import MessageBilder from './components/DragNDrop/MessageBulder';
import Billings from './pages/Billings/Billing.jsx';
import BillingDetails from './pages/Billings/BillingDetails/BillingDetails.jsx';
import TemplateManager from './pages/TemplateManager/index.jsx';
import TemplateManagerNew from './pages/TemplateManager/CreateTemplate/TemplateManagerNew.jsx';
import CreateTemplate from './pages/TemplateManager/CreateTemplate/CreateTemplate.jsx';
import EditTemplate from './pages/TemplateManager/CreateTemplate/EditTemplate.jsx';
import CronManager from './pages/CronManager/CronManager.jsx';
import DemoRequests from './pages/DemoRequest/DemoRequest.jsx';
import VoucherCodes from './pages/VoucherCodes/VoucherCodes.jsx';
import EstimatesList from './pages/Estimates/EstimatesList.jsx';
import Pages from './pages/setting/Pages/Pages.jsx';
import RedisSyc from './pages/setting/RedisSyc.jsx';
import SdkConfigPage from './pages/SdkConfig/SdkConfigPage.jsx';
import PlatformEditor from './pages/SdkConfig/PlatformEditor.jsx';


function App() {
    return (

        <ChakraProvider theme={theme}>

            <Routes>
                <Route path="/" element={<Login />} />


                <Route path="/dashboard" element={
                    <PrivateRoute>
                        <Dashboard />
                    </PrivateRoute>
                } />


                <Route path="/customer" element={
                    <PrivateRoute>
                        <Customer />

                    </PrivateRoute>} />

                <Route path="/customer-detail/:id" element={
                    <PrivateRoute>
                        <CustomerDetail />

                    </PrivateRoute>} />

                <Route path="/demo-request" element={
                    <PrivateRoute>
                        <DemoRequests />

                    </PrivateRoute>} />
                <Route path="/voucher-codes" element={
                    <PrivateRoute>
                        <VoucherCodes />

                    </PrivateRoute>} />
                <Route path="/estimates" element={
                    <PrivateRoute>
                        <EstimatesList />

                    </PrivateRoute>} />


                <Route path="/sms-price/:id" element={
                    <PrivateRoute>
                        <Price />

                    </PrivateRoute>} />
                <Route path="/message-builder" element={
                    <PrivateRoute>
                        <MessageBilder />

                    </PrivateRoute>} />

                <Route path="/other-channel-price/:id" element={
                    <PrivateRoute>
                        <PriceOtherChannel />

                    </PrivateRoute>} />
                <Route path="/sales-contract/:id" element={
                    <PrivateRoute>
                        <SaleList />

                    </PrivateRoute>} />



                <Route path="/price" element={
                    <PrivateRoute>
                        <PriceChannel />

                    </PrivateRoute>
                } />
                <Route path="/cron-manager" element={
                    <PrivateRoute>
                        <CronManager />

                    </PrivateRoute>
                } />

                <Route path="/sdk-config" element={
                    <PrivateRoute>
                        <SdkConfigPage />
                    </PrivateRoute>
                } />

                <Route path="/sdk-config/:platformId" element={
                    <PrivateRoute>
                        <PlatformEditor />
                    </PrivateRoute>
                } />
                <Route path="/billing-details/:id" element={
                    <PrivateRoute>
                        <BillingDetails />

                    </PrivateRoute>
                } />
                <Route path="/billings" element={
                    <PrivateRoute>
                        <Billings />

                    </PrivateRoute>
                } />
                <Route path="/template-manager" element={
                    <PrivateRoute>
                        <TemplateManager />

                    </PrivateRoute>
                } />
                <Route path="/template-add" element={
                    <PrivateRoute>
                        <TemplateManagerNew />

                    </PrivateRoute>
                } />
                <Route path="/template-edit/:id" element={
                    <PrivateRoute>
                        <TemplateManagerNew isEdit={true} />

                    </PrivateRoute>
                } />

                <Route path="/sale-channel" element={
                    <PrivateRoute>
                        <ChannelList />

                    </PrivateRoute>
                } />




                <Route path="/web-hook" element={
                    <PrivateRoute>
                        <WebHook />

                    </PrivateRoute>
                } />
                <Route path="/report" element={
                    <PrivateRoute>
                        <MessageLogReport />

                    </PrivateRoute>
                } />
                <Route path="/message-parser" element={
                    <PrivateRoute>
                        <MessageParser />

                    </PrivateRoute>
                } />

                <Route path="/message" element={
                    <PrivateRoute>
                        <Message />

                    </PrivateRoute>
                } />

                <Route path="/get-started" element={
                    <PrivateRoute>
                        <GetStarted />

                    </PrivateRoute>
                } />

                <Route path="/contact" element={
                    <PrivateRoute>
                        <Contact />

                    </PrivateRoute>
                } />


                <Route path="/send-message" element={
                    <PrivateRoute>
                        <SendMessage />

                    </PrivateRoute>
                } />

                <Route path="/settings" element={
                    <PrivateRoute>
                        <Setting />

                    </PrivateRoute>
                } >


                    <Route
                        path="/settings"
                        element={
                            <PrivateRoute>
                                <Country />

                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/settings/pages"
                        element={
                            <PrivateRoute>
                                < Pages />

                            </PrivateRoute>
                        }
                    />

                    <Route
                        path="/settings/operator"
                        element={
                            <PrivateRoute>
                                <Operator />

                            </PrivateRoute>
                        }
                    />

                    <Route
                        path="/settings/status"
                        element={
                            <PrivateRoute>
                                <Status />

                            </PrivateRoute>
                        }
                    />

                    <Route
                        path="/settings/variables"
                        element={
                            <PrivateRoute>
                                <Variables />

                            </PrivateRoute>
                        }
                    />

                    <Route
                        path="/settings/sdk-url"
                        element={
                            <PrivateRoute>
                                <SdkUrl />

                            </PrivateRoute>
                        }
                    />


                    <Route
                        path="/settings/channel"
                        element={
                            <PrivateRoute>
                                <Channel />

                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/settings/routing-method/:id"
                        element={
                            <PrivateRoute>
                                <RoutingMethod />

                            </PrivateRoute>
                        }
                    />



                    <Route path="/settings/channel-api-config/:id"
                        element={
                            <PrivateRoute>
                                <ChannelApiConfig />

                            </PrivateRoute>} />


                    <Route
                        path="/settings/message-type"
                        element={
                            <PrivateRoute>
                                <MessageType />

                            </PrivateRoute>
                        }
                    />

                    <Route
                        path="/settings/message-template-type"
                        element={
                            <PrivateRoute>
                                <MessageTemplateType />

                            </PrivateRoute>
                        }
                    />

                    <Route
                        path="/settings/template-message"
                        element={
                            <PrivateRoute>
                                <TemplateMessage />

                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/settings/categories"
                        element={
                            <PrivateRoute>
                                <Categories />

                            </PrivateRoute>
                        }
                    />



                    <Route
                        path="/settings/user"
                        element={
                            <PrivateRoute>
                                <User />

                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/settings/currency"
                        element={
                            <PrivateRoute>
                                <CurrencyList />

                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/settings/sms"
                        element={
                            <PrivateRoute>
                                <Sms />

                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/settings/whatsapp"
                        element={
                            <PrivateRoute>
                                <Whatsapp />

                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/settings/redis-sync"
                        element={
                            <PrivateRoute>
                                <RedisSyc />

                            </PrivateRoute>
                        }
                    />


                </Route>


            </Routes>

        </ChakraProvider>

    );
}

export default App;
